import { getRequiredMessage } from './../utils/getRequiredMessage'

export const EQUIPMENT_DETAILS = {
  FORM_TITLE: 'Equipment details',
  BUTTONS: {
    CANCEL_BUTTON_LABEL: 'Cancel',
    SAVE_BUTTON_LABEL: 'Save',
  },
  SUM_LABEL: 'Sum for: ',
  SUCCESS_EDIT: 'Your changes have been successfully saved',
  SEARCH_VALUE: 'location',
}

export const EQUIPMENT_TITLE = 'Equipment'
export const EQUIPMENT_ADD_BREADCRUMB = 'Add equipment'
export const EQUIPMENT_DETAILS_BREADCRUMB = 'Equipment details'

export const EQUIPMENT_DETAILS_FORM_VALUES = {
  EQUIPMENT_NAME: {
    ID: 'extraId',
    PLACEHOLDER: 'Please select equipment',
    LABEL: 'Equipment name',
    REQUIRED_MESSAGE: 'Please select equipment.',
  },
  PRICE: {
    ID: 'price',
    PLACEHOLDER: 'e.g. 5; 4.99',
    LABEL: 'Price',
    REQUIRED_MESSAGE: getRequiredMessage('price'),
  },
  MAX_AMOUNT: {
    ID: 'maxAmount',
    PLACEHOLDER: 'e.g. 5; 4.99',
    LABEL: 'Maximum price per rental',
    REQUIRED_MESSAGE: getRequiredMessage('maximum price per rental'),
    VALIDATION_MESSAGE:
      'Price must be less or equal to maximum price per rental.',
  },
  LOCATION: {
    ID: 'hirePoints',
    PLACEHOLDER: 'Please select a location',
    LABEL: 'Refers to location',
    REQUIRED_MESSAGE: 'Please select a location.',
  },
  SUM_FOR: {
    ID: 'priceFor',
    LABEL: 'Sum for',
    REQUIRED_MESSAGE: getRequiredMessage('sum for'),
    VALIDATION_MESSAGE: 'Please select a price type',
  },
  REQUIRED: {
    ID: 'isRequired',
    LABEL: 'Required',
    TOOLTIP:
      'This option is mandatory and will be automatically added to the booking.',
  },
}

export const RADIO_BUTTON_LABELS = {
  RENT: 'Per rental',
  DAY: 'Per day',
}
